import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { changeRoiCustomizationToMatchGlobalRoi, makeRoiCustomizationGlobalRoi, showFullRoiDetails, StoreState, updateRoiCustomizationName } from '../../store/reducers';
import RoiItem from '../customization/RoiItem';
import { selectCustomizationBaseById, selectCustomizationOutputById, selectModelById, selectRoiCustomizationById } from '../../store/selectors';
import CustomizationLabel from '../../components/customization-label';
import { Td } from '@patternfly/react-table';
import { columnIds } from '../customization/RoiTable';
import { useTranslation } from 'react-i18next';

interface ExcludedRoiProps {
    excludedRoiId: string;
    nonMatchingGlobalRoiId: string;
    excludedRoisList: string[];
}


const ExcludedRoi = (props: ExcludedRoiProps) => {
    const { excludedRoiId, nonMatchingGlobalRoiId, excludedRoisList } = props;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const roi = useSelector((state: StoreState) => selectRoiCustomizationById(state, excludedRoiId));
    const customizationOutput = useSelector((state: StoreState) => roi && roi.modelCustomizationOutputId ? selectCustomizationOutputById(state, roi.modelCustomizationOutputId) : undefined);
    const customizationBase = useSelector((state: StoreState) => customizationOutput && customizationOutput.modelCustomizationBaseId ? selectCustomizationBaseById(state, customizationOutput.modelCustomizationBaseId) : undefined);
    const segmentationModel = useSelector((state: StoreState) => customizationBase && selectModelById(state, customizationBase.segmentationModelId));

    const handleChangeToMatchGlobal = useCallback(() => {
        dispatch(changeRoiCustomizationToMatchGlobalRoi(excludedRoiId, nonMatchingGlobalRoiId));
    }, [dispatch, excludedRoiId, nonMatchingGlobalRoiId]);

    const handleMakeThisGlobal = useCallback(() => {
        dispatch(makeRoiCustomizationGlobalRoi(excludedRoiId, nonMatchingGlobalRoiId))
    }, [dispatch, excludedRoiId, nonMatchingGlobalRoiId]);

    const handleRevertName = useCallback(() => {
        dispatch(updateRoiCustomizationName(roi!.id, roi!.operation, false));
    }, [dispatch, roi]);

    const handleShowFullRoiDetails = useCallback(() => {
        dispatch(showFullRoiDetails({ currentRoiId: excludedRoiId, roiIdList: excludedRoisList, isGlobalRoi: false }));
    }, [dispatch, excludedRoiId, excludedRoisList]);

    if (!roi || !customizationOutput || !customizationBase || !segmentationModel) {
        if (!roi) { console.log(`no roi: ${excludedRoiId}`) }
        else if (!customizationOutput) console.log(`no customization output: ${roi.modelCustomizationOutputId}`)
        else if (!customizationBase) console.log(`no customization: ${customizationOutput.modelCustomizationBaseId}`)
        else if (!segmentationModel) console.log(`no segmentation model: ${customizationBase.segmentationModelId}`)
        return null;
    }

    return (
        <RoiItem
            roiId={excludedRoiId}
            extraColumnsBefore={[
                <Td key={columnIds.customization}
                    dataLabel={columnIds.customization}
                >
                    <CustomizationLabel friendlyName={segmentationModel.label} modelName={segmentationModel.modelName} customizationName={customizationBase.customizationName} />
                </Td>,
                <Td key={columnIds.targetFile}
                    dataLabel={columnIds.targetFile}
                >
                    <span className="target-file">{customizationOutput.filename}</span>
                </Td>,
            ]}
            rowActions={[
                {
                    title: t('customizeRoi.showFullRoiDetails'),
                    onClick: handleShowFullRoiDetails,
                },
                {
                    title: t('customizeRoi.global.changeToMatchGlobalRoi'),
                    onClick: handleChangeToMatchGlobal,
                },
                {
                    title: t('customizeRoi.global.makeThisGlobalRoi'),
                    onClick: handleMakeThisGlobal,
                },
                {
                    title: roi.isBuiltInRoi ? t('customizeRoi.revertNameToDefault') : t('customizeRoi.changeNameToMatchOperation'),
                    onClick: handleRevertName,
                    disabled: roi.name === roi.operation,
                },
            ]}
        />

    );
}

export default ExcludedRoi;
